//=require masonry-layout/dist/masonry.pkgd.min.js
//=require imagesloaded/imagesloaded.pkgd.min.js

$(function() {
  var $list = $('.list'),
      $listItems    = $list.find('.list-items');
  
  // Masonry
  if ($listItems.length) {
    var masonryOptions = {
      itemSelector: '.list-item',
      percentPosition: true,
      hiddenStyle: {
        opacity: 0,
        transform: 'scale(.5)'
      }
    };
    
    $listItems.masonry(masonryOptions);

    $listItems.imagesLoaded(function () {
      $listItems.masonry(masonryOptions);
    });
  }
  
  // Ajax
  $list.on('click', '.list-next, .list-previous', function (e) {
    e.preventDefault();
    var $anchor = $(this),
        url     = $anchor.attr('href'),
        append  = $anchor.hasClass('list-next');

    $.ajax(url, {
      beforeSend: function () {
        $anchor.addClass('is-loading');
      },
      success: function (data) {
        var $data       = $(data),
            $dataItems  = $data.find('.list-item'),
            $dataAnchor = $data.find(append ? '.list-next' : '.list-previous');

        // Items
        if ($dataItems.length) {
          $dataItems.imagesLoaded(function() {
            $listItems[append ? 'append' : 'prepend']($dataItems).masonry(append ? 'appended' : 'prepended', $dataItems);
          });
          if (history && history.replaceState) history.replaceState({}, null, url);
        }
        
        // Anchor
        if ($anchor.length) {
          if ($dataAnchor.length) {
            $anchor.replaceWith($dataAnchor);
            $anchor = $dataAnchor;
          } else {
            $anchor.remove();
          }
        }

        $anchor.removeClass('is-loading');
      },
      error: function () {
        $anchor.removeClass('is-loading');
        return false;
        document.location.href = url;
      }
    });
  });
});
